import React from 'react'
import rootReducer from '../reducers'
import PropTypes from 'prop-types'
import { GlobalProvider } from 'Shared/global_context'
import configureStore from 'Shared/configure_store'
import AppDashboardLayout from './app_dashboard_layout'

const AppDashboardRoot = ({ initialState }) => {
  const state = {
    buttons: initialState.buttons,
    directories: initialState.directories,
    nextTempId: 1,
    club_logo: initialState.club_logo,
    dashboardItems: initialState.dashboard_items,
    club_name: initialState.club_name,
    rounds_days_before_date: initialState.rounds_days_before_date ?? 0,
    max_rounds_days_before_date: initialState.max_rounds_days_before_date,
    chat_available: initialState.chat_available ?? false,
    chat_member_messaging_enabled: initialState.chat_member_messaging_enabled ?? true,
    chat_restrict_minors: initialState.chat_restrict_minors ?? false,
  }

  const store = configureStore(rootReducer, state, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

  return (
    <GlobalProvider store = { store }>
      <AppDashboardLayout />
    </GlobalProvider>
  )
}

AppDashboardRoot.propTypes = {
  initialState: PropTypes.any,
  directories: PropTypes.any,
}

export default AppDashboardRoot

